import React, { useState } from 'react';
import { hasRole, useAuth } from "../../../services/auth";
import { Container, Typography } from '@mui/material';
import NotificationForm from './NotificationForm';
import PasswordForm from './PasswordForm';
import { sendNotificationToAll } from '../../../services/request-api';

const NotiApp = () => {
  const [user] = useAuth();
  const [isPromptOpen, setIsPromptOpen] = useState(false);
  const [notificationData, setNotificationData] = useState(null);

  const handleFormSubmit = (data) => {
    setNotificationData(data);
    setIsPromptOpen(true);
  };

  const handlePasswordSubmit = (password) => {
    if (password === 'năn nỉ') {
      sendNotificationToAll({title: notificationData.title, body: notificationData.body})
      .then(res => {alert('Notification sent successfully!');})
      .catch(err => console.log(err))
    } else {
        alert('Wrong password!!')
    }
    console.log('Sending notification:', {
      ...notificationData,
      password,
    });
    setIsPromptOpen(false);
  };

  const handleCancel = () => {
    setIsPromptOpen(false);
    setNotificationData(null);
  };

  return (
    <>
      {
        hasRole(user, "super_admin") ? (
          <Container maxWidth="sm" style={{ marginTop: '50px' }}>
            <Typography variant="h4" gutterBottom>
              Send Notification
            </Typography>
            <NotificationForm onSubmit={handleFormSubmit} />
            <PasswordForm
              open={isPromptOpen}
              onSubmit={handlePasswordSubmit}
              onCancel={handleCancel}
            />
        </Container>
        ) : (
          <Typography> 🖕 Permission Denied</Typography>
        )
      }
    </>

  );
};

export default NotiApp;
